<ui-page-container>
  <mat-card class="media-page-content">
    <mat-card-title>
      {{'Documenti bibliografici' | translate }}
    </mat-card-title>
    <mat-card-content>
      <ui-table
        [rowSelection]="'checkbox'"
        [fields]="fields"
        [filters]="filters$ | async"
        [pager]="pager$"
        [reload]="reload$"
        [itemsPage]="(page$ | async)?.current"
        [itemsPerPage]="(page$ | async)?.limit"
        [contextMenuActions]="contextMenus"
        (itemsPageChange)="applyChangePageHandler($event)"
        (select)="selectHandler($event)"
        (rowAction)="manageRowActions($event)">
        <div tableActions>
          <app-entity-actions
            className="DocumentoBib"
            [selectedItemsCount]="selectedItems?.length"
            [config]="{ showExport: !!isExportEnable }"
            (export)="exportHandler()"
            (add)="addHandler()"
            (delete)="deleteSelectedHandler()"
            (collectionAdd)="addToCollectionHandler()">
          </app-entity-actions>
        </div>
        <div tableFilters>
          <ui-filters
            [dialogFilters]="MobileFiltersComponent"
            (action)="applyFilterWithDelayHandler($event)">
            <app-source-bibliographic-filters
              [filters]="filtersObj$ | async"
              #desktopFilter>
            </app-source-bibliographic-filters>
          </ui-filters>
        </div>
      </ui-table>
    </mat-card-content>
  </mat-card>
</ui-page-container>
